import { createIcon } from './factory'
import Bold from './info.bold.svg?react'
import Duotone from './info.duotone.svg?react'
import Fill from './info.fill.svg?react'
import Regular from './info.regular.svg?react'

export const Info = createIcon({
  regular: Regular,
  bold: Bold,
  fill: Fill,
  duotone: Duotone,
})
